import React from 'react';
import styled from 'styled-components';

import { DialogBodyProps } from '../../types';
import { DialogWrapper } from '../DialogWrapper';
import { FormInputAside } from './FormInputAside';
import { Headings } from './Headings';
import { InputGroup } from './InputGroup';
import { RadioGroup } from './RadioGroup';

const RadioInputsWrapper = styled.div`
  flex-basis: 100%;
  flex-grow: 1;
  position: relative;
`;

export function FormInput(props: DialogBodyProps) {
  return (
    <DialogWrapper>
      <RadioInputsWrapper>
        <Headings isEditing={props.isEditing} />

        <RadioInputs {...props} />
      </RadioInputsWrapper>

      <FormInputAside />
    </DialogWrapper>
  );
}

function RadioInputs(props: DialogBodyProps) {
  const [
    isFundraisingLinkSelected,
    setIsFundraisingLinkSelected,
  ] = React.useState(true);

  return (
    <>
      <RadioGroup
        {...props}
        isFundraisingLinkSelected={isFundraisingLinkSelected}
        setIsFundraisingLinkSelected={setIsFundraisingLinkSelected}
      />
      <InputGroup
        {...props}
        isFundraisingLinkSelected={isFundraisingLinkSelected}
        setIsFundraisingLinkSelected={setIsFundraisingLinkSelected}
      />
    </>
  );
}
